import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

const Z_INDEX = 100;

const LegendContainer = styled.dialog`
    display: flex;
    justify-content: center;
    background: none;
    border: none;
    padding: 0;
    margin: 0;
    min-width: 100vw;
    min-height: 100vh;
    z-index: ${Z_INDEX + 1};
`;

export const DialogContainer = styled.div`
    background: ${({ theme }) => theme.Surface.Opposite.primary};
    height: 100vh;
    left: 0;
    opacity: 0.5;
    position: fixed;
    top: 0;
    width: 100vw;
    z-index: ${Z_INDEX};
`;

const Legend = styled.div`
    background-color: ${({ theme }) => theme.Surface.primary};
    padding: 16px;
    text-align: left;
    overflow-y: hidden;

    ${BaseStyle.Mixins.screenSizes.medium} {
        border-radius: 16px;
        box-shadow: ${BaseStyle.Mixins.utility.fadedBoxShadow};
        height: fit-content;
        margin: 20px;
        max-width: 990px;
        padding: 32px;
        position: relative;
        top: 200px;
    }
`;

const LegendLabel = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['24b']};
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
    padding-bottom: 8px;
    text-transform: capitalize;

    span {
        color: ${({ theme }) => theme.Text.primary};
    }
`;

const LegendItem = styled.li`
    ${BaseStyle.Mixins.fontStyles.ui['14m']};
    -webkit-font-smoothing: antialiased;
    color: ${({ theme }) => theme.Text.primary};
    display: inline-block;
    padding-bottom: 8px;
    width: 100%;
    vertical-align: top;

    ${BaseStyle.Mixins.screenSizes.medium} {
        width: 33%;
        padding: 2px 8px;
    }
`;

const LegendLink = styled.a`
    ${BaseStyle.Mixins.gaps.extraSmall};
    -webkit-font-smoothing: antialiased;
    display: flex;

    && {
        color: ${({ theme }) => theme.Text.primary};

        &:hover {
            color: ${({ theme }) => theme.Text.primary};
        }
    }

    &:hover {
        cursor: pointer;
        font-weight: bold;
    }
`;

const LegendClose = styled.span`
    ${BaseStyle.Mixins.fontStyles.ui['36m']};
    color: ${({ theme }) => theme.Text.primary};
    align-items: center;
    cursor: pointer;
    display: inline-block;
    text-align: center;

    svg {
        width: 30px;
        height: 30px;
    }
`;

export const LegendList = styled.div`
    display: flex;
    overflow-y: auto;
    height: calc(100% - 30px);
`;

export { LegendContainer, Legend, LegendItem, LegendLink, LegendLabel, LegendClose };
